import { createSlice } from "@reduxjs/toolkit";
import { DonationInitialStatus } from "../../../types/donation/donation";
import { createDonationAsync, getAllDonationAsync } from "./donationApi";

const initialState: DonationInitialStatus<any> = {
  loading: false,
  manageLoading: false,
  donationList: [],
  countDonation: 0,
};

const donationSlice = createSlice({
  name: "admin-donation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // create
    builder
      .addCase(createDonationAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(createDonationAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(createDonationAsync.rejected, (state) => {
        state.manageLoading = false;
      });

    // get all
    builder
      .addCase(getAllDonationAsync.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getAllDonationAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.donationList = action.payload.data;
        state.countDonation = action.payload.length;
      })
      .addCase(getAllDonationAsync.rejected, (state) => {
        state.loading = false;
        state.donationList = [];
        state.countDonation = 0;
      });
  },
});

export default donationSlice;
